import {
  IsNotEmpty,
  IsDateString,
  IsBoolean,
  IsString,
  IsNumber,
  IsOptional,
  Min,
} from 'class-validator';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class CreateVacationFillingDto {
  @IsNumber()
  @Min(1)
  @IsOptional()
  minDurationDays: number;

  @IsString()
  @IsOptional()
  minDurationUnit: string;

  @IsBoolean()
  @IsOptional()
  weekendExclusion: boolean;

  @IsBoolean()
  @IsOptional()
  minDuration: boolean;

  @IsNumber()
  @Min(1)
  @IsOptional()
  maxDurationDays: number;

  @IsString()
  @IsOptional()
  maxDurationUnit: string;

  @IsBoolean()
  @IsOptional()
  maxDuration: boolean;

  @IsDateString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  employeeDeadline: string;

  @IsBoolean()
  @IsOptional()
  mustScheduleAllDays: boolean;

  @IsBoolean()
  @IsOptional()
  mustSchedule14days: boolean;

  @IsBoolean()
  @IsOptional()
  daysMustBeDivisibleBy: boolean;

  @IsString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  employeeCanSeeVacations: string;

  @IsString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  allowEmployeeComment: string;

  @IsNumber()
  // eslint-disable-next-line no-magic-numbers
  @Min(2)
  @IsOptional()
  daysMustBeDivisibleByNumber: number;

  @IsBoolean()
  @IsOptional()
  limitToCalculatedDays: boolean;

  @IsString()
  @IsOptional()
  companyComment: string;
}
